import React from 'react';
import Icon from '../../../components/AppIcon';

const StatCard = ({ icon, label, value, trend, trendValue, color = 'primary' }) => {
  const colorClasses = {
    primary: 'bg-primary/10 text-primary',
    success: 'bg-success/10 text-success',
    warning: 'bg-warning/10 text-warning',
    accent: 'bg-accent/10 text-accent'
  };

  return (
    <div 
      className="bg-white border-2 border-slate-200 rounded-lg p-4 md:p-6 transition-smooth hover:elevation-md"
      style={{
        boxShadow: '0 15px 40px rgba(0,0,0,0.15), 0 8px 20px rgba(0,0,0,0.1)'
      }}
    >
      <div className="flex items-start justify-between mb-3">
        <div className={`w-10 h-10 md:w-12 md:h-12 ${colorClasses?.[color]} rounded-lg flex items-center justify-center flex-shrink-0`}>
          <Icon name={icon} size={20} />
        </div>
        {trend && (
          <div className={`flex items-center gap-1 px-2 py-1 rounded-md ${trend === 'up' ? 'bg-success/10 text-success' : 'bg-error/10 text-error'}`}>
            <Icon name={trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={14} />
            <span className="caption font-medium">{trendValue}</span>
          </div>
        )}
      </div>
      <p className="caption text-muted-foreground mb-1">{label}</p>
      <p className="text-2xl md:text-3xl font-semibold text-foreground">{value}</p>
    </div>
  );
};

export default StatCard;